import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLang } from '@/hooks/useLang';
import { buildAlternates } from '@/lib/seoUrls';
import HeroSection from '@/components/sections/HeroSection';
import MarketAccessCTA from '@/components/sections/MarketAccessCTA';
import AboutPreview from '@/components/sections/AboutPreview';
import ProductsPreview from '@/components/sections/ProductsPreview';
import SourcingMap from '@/components/sections/SourcingMap';
import ContactCTA from '@/components/sections/ContactCTA';

const Index = () => {
  const { t, i18n } = useTranslation();
  const lang = useLang();
  const seo = buildAlternates('/');
  const canonical = seo.canonicalForLang(lang);
  const ogLocaleMap: Record<string, string> = { fr: 'fr_FR', en: 'en_US', es: 'es_ES', it: 'it_IT' };
  const ogLocale = ogLocaleMap[i18n.language.split('-')[0]] || 'fr_FR';
  return (
    <>
      <Helmet>
        <title>{t('seo.home.title')}</title>
        <meta name="description" content={t('seo.home.description')} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={t('seo.home.title')} />
        <meta property="og:description" content={t('seo.home.ogDescription')} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={ogLocale} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('seo.home.title')} />
        <meta name="twitter:description" content={t('seo.home.ogDescription')} />
        {seo.alternates.map((a) => (
          <link key={a.lang} rel="alternate" hrefLang={a.lang} href={a.href} />
        ))}
        <link rel="alternate" hrefLang="x-default" href={seo.xDefault} />
      </Helmet>

      <HeroSection />
      <MarketAccessCTA />
      <AboutPreview />
      <ProductsPreview />
      <SourcingMap />
      <ContactCTA />
    </>
  );
};

export default Index;
